import state from "./state";

export default {
  getStateNama: () => {
    return state.nama;
  },
};
